import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;
const CHUNK_SIZE = 100;

const clearStats = async () => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-clear-stats`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
  });

  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const uploadStatsChunk = async (chunk) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-upload-stats`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(chunk),
  });

  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const uploadStats = async (data) => {
  // Clear stats collection once
  try {
    await clearStats();
  } catch {
    return;
  }

  // Batch upload to both collections
  const totalChunks = Math.ceil(data.length / CHUNK_SIZE);

  for (let i = 0; i < totalChunks; i++) {
    const chunk = data.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
    try {
      await uploadStatsChunk(chunk);
    } catch {
      return;
    }
  }

  return true;
};

export { uploadStats };
